module.exports = __webpack_public_path__ + "media/ja.74a3024d.mp3";